import React from "react";
import Footer from "./Footer";

function PrivacyPolicy() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      
      {/* ===== CONTENT ===== */}
      <div style={{ flex: 1, padding: "40px", maxWidth: 900, margin: "auto" }}>
        <h1 style={{ textAlign: "center", marginBottom: 20 }}>
          Privacy Policy
        </h1>

        <p>
          At <b>KingShop</b>, we value your privacy and are committed to
          protecting your personal information. This Privacy Policy explains
          how we collect, use, and safeguard your data.
        </p>

        <h3>1. Information We Collect</h3>
        <p>
          We may collect personal details such as your name, email address,
          phone number, shipping address, and payment-related information when
          you register, place an order, or contact us.
        </p>

        <h3>2. How We Use Your Information</h3>
        <ul>
          <li>To process orders and deliver products</li>
          <li>To communicate order updates and support</li>
          <li>To improve our website and services</li>
          <li>To send important notifications and offers</li>
        </ul>

        <h3>3. Data Security</h3>
        <p>
          We use industry-standard security measures to protect your personal
          data. However, no method of transmission over the internet is 100%
          secure.
        </p>

        <h3>4. Sharing of Information</h3>
        <p>
          We do not sell or rent your personal data to third parties. Information
          may be shared only with trusted partners for payment processing,
          delivery services, or legal requirements.
        </p>

        <h3>5. Cookies</h3>
        <p>
          KingShoppy may use cookies to enhance user experience, analyze traffic,
          and personalize content. You can disable cookies in your browser
          settings.
        </p>

        <h3>6. Your Rights</h3>
        <p>
          You have the right to access, update, or request deletion of your
          personal data by contacting our support team.
        </p>

        <h3>7. Policy Updates</h3>
        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page.
        </p>

        <h3>8. Contact Us</h3>
        <p>
          If you have any questions regarding this Privacy Policy, please contact
          us at <b>kingshoppy.as@gmail.com</b>.
        </p>

        <p style={{ marginTop: 30, fontSize: 14, color: "#555" }}>
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </div>

      {/* ===== FOOTER ===== */}
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
